import { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent, Button } from "@heroui/react";
import { Calendar as CalendarIcon, X } from "lucide-react";
import CalendarPopoverPanel from "@/shared/components/ui/DatePicker/CalendarPopoverPanel";

const DatePickerDropdown = ({
  value = null,
  onChange,
  placeholder = "Select Date",
  minDate = null,
  maxDate = null,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const formatDisplayDate = (dateValue) => {
    if (!dateValue) return "";

    try {
      const date = new Date(dateValue);

      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    } catch {
      return "";
    }
  };

  const handleConfirm = (dateString) => {
    onChange?.(dateString);
    setIsOpen(false);
  };

  const handleClearDate = (e) => {
    e.stopPropagation();
    onChange?.("");
  };

  const displayValue = formatDisplayDate(value);

  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      placement="bottom-start"
      classNames={{
        content: "p-0 border-none shadow-lg",
      }}
    >
      <PopoverTrigger>
        <div className="flex items-center gap-1.5 border-b border-gray-300 dark:border-gray-700 pb-2 cursor-pointer w-full group hover:border-secondary transition-colors">
          <CalendarIcon
            size={14}
            className="text-gray-500 dark:text-gray-400 flex-shrink-0"
            strokeWidth={1.7}
          />
          <div className="flex-1 flex items-center justify-between min-w-0">
            <span
              className={`text-[0.763rem] font-inter truncate ${
                displayValue ? "text-gray-800 dark:text-gray-100" : "text-gray-500 dark:text-gray-400"
              }`}
            >
              {displayValue || placeholder}
            </span>
            {displayValue && !disabled && (
              <Button
                isIconOnly
                size="sm"
                variant="light"
                className="h-6 w-6 min-w-6 opacity-0 group-hover:opacity-100 transition-opacity"
                onClick={handleClearDate}
              >
                <X size={14} className="text-gray-500" />
              </Button>
            )}
          </div>
        </div>
      </PopoverTrigger>

      <PopoverContent>
        <CalendarPopoverPanel
          value={value}
          minDate={minDate}
          maxDate={maxDate}
          onConfirm={handleConfirm}
          onCancel={() => setIsOpen(false)}
        />
      </PopoverContent>
    </Popover>
  );
};

export default DatePickerDropdown;
